<template>
	<!-- 底部 banner 区域 -->
    <section class="bottom-banner-section">
      <div class="container bottom-banner-section-container">
        <div class="d-flex flex-column justify-content-center align-items-center content">
          <!-- <div>收付無界 系統無縫</div>
          <div class="pt-2 pb-3">UUPay 為你推動業務</div> -->
          <div class="pb-2" v-for="item in info">{{ item }}</div>
          <div><button class="banner-btn mt-3" @click="contactUs">聯繫我們</button></div>
        </div>
      </div>
    </section>
</template>
<script>
export default {
  name: 'UUPayBannerContact',
  props: {
    info: [String, Array]
  },
  data() {
    return {
    }
  },
  methods: {
    contactUs() {
      console.log('聯繫我們');
    }
  }
}
</script>
<style scoped>
.bottom-banner-section {
  margin: 5rem 0;
  /*background-color: #2b2d42;*/
  
}
.bottom-banner-section-container {
  height: 340px;
  width: 83%;
  border-radius: 30px;
  color: white;
  background-image: url('/static/contact_bg.png');
  background-position: center;  
  background-size: cover;      
  background-repeat: no-repeat;
}
.bottom-banner-section .content {
  height: 340px;
  font-size: 36px;
  font-weight: 600;
}
.bottom-banner-section .banner-btn {
  width: 140px;
  height: 50px;
  border-radius: 30px;
  font-size: 14px;
  line-height: 100%;
  color: #fff;
  border: none;
  background: linear-gradient(to right, 
    #d054aa 0%, 
    #5a0a7e 100%);
}
</style>


// WEBPACK FOOTER //
// src/components/uupayBannerContact.vue